import tw from 'twin.macro';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const SearchInput = styled.input`
  ${tw`rounded-[6px] border border-neutrals-n6`}
  ${tw`p-[4px] pr-1 text-left pl-2`}
  ${tw`h-[46px] mt-[4px]`}

  ${css`
    [type='search']::-webkit-search-cancel-button,
    [type='search']::-webkit-search-decoration {
      -webkit-appearance: none;
      appearance: none;
    }
  `}

  ${css`
    [type='search'] {
      outline: none;
      ${tw`font-inter h-[42px]`}
      ${tw`pr-4 lg:px-2`}
      ${tw`w-[85%]`}
    }
  `}


  ${css`
    & .ais-SearchBox-submitIcon,
    & .ais-SearchBox-reset {
      filter: invert(39%) sepia(8%) saturate(494%) hue-rotate(175deg) brightness(95%) contrast(85%);
      ${tw`text-neutrals-n7`}
      ${tw`absolute`}
      ${tw`top-[37px] lg:top-[45px]`}
    }
  `}

  ${css`
    & .ais-SearchBox-submitIcon {
      ${tw`scale-[2]`}
      ${tw`right-[45px] lg:right-[15px]`}
    }
  `}

  ${css`
    & .ais-SearchBox-reset {
      ${tw`text-neutrals-n7`}
      ${tw`right-[75px] lg:right-[40px]`}
    }
  `}
`;
